import React from 'react';
import { Grid, GridItem, Heading, TextInput, typography } from '@digitools/honest-ui';
import useAsDataContext from '../hooks/useAsDataContext';
import useValidPhoneMessage from '../../../hooks/fieldValidation/useValidPhoneMessage';
import useExperience from '../../../hooks/useExperience';
import { validateEmailStr } from '../utils/validationUtils';
import { phoneMask } from 'src/utils/validationUtils';
import { PreferredContactInformationText } from '../constants/PreferredContactInformationText';
import useTranslate from 'src/hooks/useTranslate';
const halfWidth = { colSpan: 4, colSpanMd: 3, colSpanLg: 6 };
/**
 * Section of fields for contact information, for use within a <Form>
 */
const PreferredContactInformation = () => {
    const { claimantData } = useAsDataContext();
    const validatePhoneRequired = useValidPhoneMessage();
    const { language } = useExperience();
    const { t } = useTranslate();
    return (<div data-public={true} data-testid='preferred-contact-information' className='hui-mb-xl-2'>
      {/* TODO(honest-ui gap): Heading needs a size prop; using inline typography overrides */}
      <Heading as='h4' weight='bold' className='hui-mb-md' style={{ fontSize: typography.fontSize.lg, lineHeight: typography.lineHeight.xl }}>
        {t(PreferredContactInformationText.contactInfoHeading)}
      </Heading>
      <Grid noGutter style={{ rowGap: '0.5rem' }}>
        <GridItem {...halfWidth}>
          <TextInput data-testid='phone' name={'claimantData.empPhoneNum'} label={t(PreferredContactInformationText.preferredPhoneQuestionLabel)} required={true} type={'text'} validate={validatePhoneRequired} transform={(value) => phoneMask(value) ?? ''} defaultValue={phoneMask(claimantData?.empPhoneNum ?? '') ?? ''} data-private={true}/>
        </GridItem>
        <GridItem {...halfWidth} data-private={true}>
          <TextInput data-testid='email' name={'claimantData.empEmail'} label={t(PreferredContactInformationText.preferredEmailAddressQuestionLabel)} required={true} type={'text'} validate={(value) => validateEmailStr(value, PreferredContactInformationText.preferredEmailAddressQuestionLabel, language)} defaultValue={claimantData?.empEmail} data-private={true}/>
        </GridItem>
      </Grid>
    </div>);
};
export default PreferredContactInformation;
